import { FC } from 'react';
import styled from 'styled-components';
import { TranslatedItem } from 'src/hooks/directus/useTranslateItem';
import { media } from 'src/styles/designs';
import { useTranslate } from 'react-t7e';
import { H2 } from 'src/components/common/typography/Header';
import { motion } from 'framer-motion';
import { makeTransition } from 'src/utils/motion/transitions';
import { NeauviaItem } from 'src/models/directus';
import { Markdown } from 'vendor/mods/markdown/components/Markdown';
import { SpeakerTile } from 'src/modules/materials/components/SpeakerTile';

const Description = styled(motion.div)`
  font-weight: 300;
  line-height: 150%;
  font-size: 14px;
  color: ${({ theme }) => theme.text.palette.primary};

  ${media.w.greaterThanOrEqual.desktop} {
    font-size: 16px;
  }
`;

const Speakers = styled(motion.div)`
  display: grid;
  grid-auto-flow: row;
  grid-gap: 15px;
`;

const SpeakersList = styled.ul`
  display: grid;
  grid-auto-flow: row;
  grid-gap: 13px;

  ${media.w.greaterThanOrEqual.desktop} {
    display: flex;
    flex-direction: row;

    margin: 0px -10px;

    & > * {
      margin: 10px;
    }
  }
`;

export const DetailsTab: FC<{
  item: TranslatedItem<NeauviaItem> | undefined;
}> = ({ item }) => {
  const { _ } = useTranslate();

  const speakers = item && 'speakers' in item ? item.speakers : null;

  return (
    <>
      {item?.description && (
        <Description
          variants={makeTransition({
            fade: true,
            from: 'bottomMore',
          })}
        >
          <Markdown>{item.description}</Markdown>
        </Description>
      )}
      {Number(speakers?.length) > 0 && (
        <Speakers
          variants={makeTransition({
            fade: true,
            from: 'bottomMore',
          })}
        >
          <H2 as="h3">{_('Featuring')}</H2>
          <SpeakersList>
            {speakers?.map((s) => (
              <li key={s.people_id.id}>
                <SpeakerTile speaker={s.people_id} />
              </li>
            ))}
          </SpeakersList>
        </Speakers>
      )}
    </>
  );
};
